import { Context, Effect, Layer } from "effect";
import type { ResourceFailure } from "@workerstation/shared/errors/resource";
export class WorkflowBrowserIo extends Context.Service<WorkflowBrowserIo, {
  readonly prompt: (message: string, initial?: string) => Effect.Effect<string | null, ResourceFailure>;
  readonly alert: (message: string) => Effect.Effect<void, ResourceFailure>;
  readonly copy: (text: string) => Effect.Effect<void, ResourceFailure>;
}>()("workerstation/frontend/WorkflowBrowserIo") {}
export const WorkflowBrowserIoTest = (overrides: Partial<Context.Service.Shape<typeof WorkflowBrowserIo>> = {}) => Layer.succeed(WorkflowBrowserIo, { prompt: () => Effect.succeed(null), alert: () => Effect.void, copy: () => Effect.void, ...overrides });
